import { useEffect } from 'react'

import { studentController } from '@/controller/student.controller'
import useRepository from '@/hooks/useRepository'
import { AttendanceGroupService } from '@/page/Academy/Attendance/AttendanceGroup.service'
import { LessonGroupService } from '@/page/Lesson/_service'
import commonRepo from '@/repository/common.repo'
import { RouteName } from '@/router'
import StudentGroupAccordionService from '@/service/StudentGroupAccordion.service'

export const useSetStudentGroups = () => {
  const lessonGroupService = useRepository(LessonGroupService)
  const studentGroupAccordionService = useRepository(
    [StudentGroupAccordionService, RouteName.lesson],
    RouteName.lesson,
  )
  const attendanceGroupService = useRepository([AttendanceGroupService, RouteName.attendance])

  useEffect(() => {
    if (commonRepo.academy) {
      // 학생 리스틀를 조회 -> then 이후에는 케싱 데이터를 사용
      studentController.fetchStudentGroups().then(() => {
        studentGroupAccordionService.initStudentGroup()
        lessonGroupService.fetchStudentGroups()
        attendanceGroupService.fetchStudentGroups()
      })
    }
  }, [commonRepo.academy, commonRepo.academy?.studentCount])
}
